import { render, staticRenderFns } from "./store-type.vue?vue&type=template&id=bc9881aa"
import script from "./store-type.vue?vue&type=script&lang=ts"
export * from "./store-type.vue?vue&type=script&lang=ts"
import style0 from "./store-type.vue?vue&type=style&index=0&id=bc9881aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports